var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Número:"),
              _c("span", [
                _vm._v(_vm._s(_vm.documento.numeroDeclaracao || "-"))
              ])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Processo:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.numeroProcesso || "-"))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Interessado:"),
              _c("span", [
                _vm._v(_vm._s(_vm.documento.nomeRazaoSocialInteressado || "-"))
              ])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Regularização Fundiária:"),
              _c("span", [_vm._v(_vm._s(_vm.tipoCadastro))])
            ])
          ]),
          _vm.documento.numeroReciboCar
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info" }, [
                  _vm._v("Número recibo CAR:"),
                  _c("span", [
                    _vm._v(_vm._s(_vm.documento.numeroReciboCar || "-"))
                  ])
                ])
              ])
            : _c(
                "div",
                [
                  _c("el-col", { attrs: { sm: 24 } }, [
                    _c("p", { staticClass: "info" }, [
                      _vm._v("Nome do Imóvel:"),
                      _c("span", [
                        _vm._v(_vm._s(_vm.documento.nomeImovel || "-"))
                      ])
                    ])
                  ]),
                  _c("el-col", { attrs: { sm: 24 } }, [
                    _c("p", { staticClass: "info" }, [
                      _vm._v("Município:"),
                      _c("span", [
                        _vm._v(_vm._s(_vm.documento.nomeMunicipioImovel || "-"))
                      ])
                    ])
                  ]),
                  _c("el-col", { attrs: { sm: 24 } }, [
                    _c("p", { staticClass: "info" }, [
                      _vm._v("Área do Imóvel:"),
                      _c("span", [
                        _vm._v(_vm._s(_vm.areaFormatada) + " hectare(s)")
                      ])
                    ])
                  ])
                ],
                1
              ),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Data da expedição:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.dataCriacao))])
            ])
          ]),
          _vm._t("baixar"),
          _c("el-row", { staticClass: "dados-doc" }, [
            _c(
              "div",
              { staticClass: "link-download" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: "cloud-download-alt" }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.downloadDoc(_vm.documento.id)
                      }
                    }
                  },
                  [_vm._v("  Baixar Documento")]
                )
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ca10692", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ca10692","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/DeclaracaoTramiteAutentica.vue
// module id = null
// module chunks = 